import type { ComponentProps } from 'react';

import { SkipForwardIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { useMedia } from '..';

export function SkipForwardButton(skipForwardButtonProps: ComponentProps<typeof Button>) {
  const { onClick, ...props } = skipForwardButtonProps;
  const { skip } = useMedia();

  return (
    <Button
      size="sm"
      type={'button'}
      variant={'ghost'}
      onClick={(e) => {
        e.stopPropagation();
        skip(10);
        onClick?.(e);
      }}
      {...props}
    >
      <SkipForwardIcon />
    </Button>
  );
}
